/**
 * Free shipping promotion + fixed viewport sticky Add to Cart
 * Performance: no touchmove polling, no 1s loops unless a countdown is visible.
 */
(function () {
  'use strict';

  var CHICAGO_TZ = 'America/Chicago';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function qs(sel) {
    try {
      return document.querySelector(sel);
    } catch (e) {
      return null;
    }
  }

  function chicagoWallTimeToUtcMs(year, month, day, hour24, minute, second) {
    second = second || 0;
    var utcGuess = Date.UTC(year, month - 1, day, hour24, minute, second);
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: CHICAGO_TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    function partsToUtc(ms) {
      var parts = formatter.formatToParts(new Date(ms));
      var map = {};
      parts.forEach(function (p) {
        if (p.type !== 'literal') map[p.type] = p.value;
      });
      var h = parseInt(map.hour, 10);
      if (h === 24) h = 0;
      return Date.UTC(
        parseInt(map.year, 10),
        parseInt(map.month, 10) - 1,
        parseInt(map.day, 10),
        h,
        parseInt(map.minute, 10),
        parseInt(map.second, 10)
      );
    }

    var desiredAsUtc = Date.UTC(year, month - 1, day, hour24, minute, second);
    var offset = partsToUtc(utcGuess) - utcGuess;
    var corrected = desiredAsUtc - offset;
    offset = partsToUtc(corrected) - corrected;
    return desiredAsUtc - offset;
  }

  function readEndMs(el) {
    var year = parseInt(el.getAttribute('data-promo-end-year'), 10);
    var month = parseInt(el.getAttribute('data-promo-end-month'), 10);
    var day = parseInt(el.getAttribute('data-promo-end-day'), 10);
    var hour = parseInt(el.getAttribute('data-promo-end-hour'), 10);
    var minute = parseInt(el.getAttribute('data-promo-end-minute'), 10);
    var ampm = (el.getAttribute('data-promo-end-ampm') || 'pm').toLowerCase();
    if (!year || !month || !day || isNaN(hour) || isNaN(minute)) return 0;
    var hour24 = hour % 12;
    if (ampm === 'pm') hour24 += 12;
    return chicagoWallTimeToUtcMs(year, month, day, hour24, minute, 59);
  }

  function formatCountdown(distance) {
    if (distance <= 0) return 'Ended';
    var days = Math.floor(distance / 86400000);
    var hours = Math.floor((distance % 86400000) / 3600000);
    var mins = Math.floor((distance % 3600000) / 60000);
    var secs = Math.floor((distance % 60000) / 1000);
    if (days > 0) return days + 'd ' + pad(hours) + 'h ' + pad(mins) + 'm';
    return pad(hours) + ':' + pad(mins) + ':' + pad(secs);
  }

  function initPromo() {
    var roots = document.querySelectorAll('[data-promo-root]');
    if (!roots.length) return;

    var countdownNodes = [];
    var latestEnd = 0;

    roots.forEach(function (el) {
      var end = readEndMs(el);
      var active = end > Date.now();
      if (el.closest && el.closest('#StickyAtc')) {
        el.style.display = active ? '' : 'none';
      } else {
        el.hidden = !active;
      }
      if (active && end > latestEnd) latestEnd = end;
      var countdownEl = el.querySelector('[data-promo-countdown-el]');
      if (active && countdownEl && el.getAttribute('data-promo-countdown') === 'true') {
        countdownNodes.push({ el: el, countdownEl: countdownEl, end: end });
      }
    });

    if (!countdownNodes.length) {
      // No live countdown — schedule one hide at expiry if needed
      if (latestEnd > Date.now()) {
        var wait = Math.min(latestEnd - Date.now() + 250, 2147483647);
        setTimeout(initPromo, wait);
      }
      return;
    }

    function tick() {
      var now = Date.now();
      var anyLeft = false;
      countdownNodes.forEach(function (item) {
        var distance = item.end - now;
        if (distance <= 0) {
          item.el.hidden = true;
          item.countdownEl.textContent = '';
        } else {
          anyLeft = true;
          item.countdownEl.textContent = formatCountdown(distance);
        }
      });
      if (!anyLeft) {
        clearInterval(timer);
        initPromo();
      }
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function measureBottomOffset() {
    var offset = 0;

    function bump(el) {
      if (!el) return;
      try {
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
          return;
        }
        var rect = el.getBoundingClientRect();
        if (rect.height < 8) return;
        if (rect.bottom < window.innerHeight - 8) return;
        if (rect.top > window.innerHeight) return;
        offset = Math.max(offset, Math.ceil(window.innerHeight - rect.top));
      } catch (e) {}
    }

    bump(document.getElementById('preview-bar-iframe'));
    bump(qs('.preview-bar__container'));
    bump(document.getElementById('shopify-chat'));
    bump(qs('#ShopifyChat'));
    bump(qs('iframe[title*="chat"]'));
    bump(qs('.intercom-lightweight-app'));
    bump(qs('#intercom-container'));
    bump(qs('.tidio-chat'));
    bump(qs('#tidio-chat'));
    bump(qs('[data-gorgias-widget]'));
    bump(qs('.crisp-client'));
    bump(qs('[data-bottom-nav]'));
    bump(qs('.mobile-bottom-nav'));
    bump(qs('.bottom-nav'));
    bump(qs('.footer-mobile-nav'));

    return offset;
  }

  function cartDrawerOpen() {
    var panel = qs('.w-commerce-commercecartcontainerwrapper--cartType-rightSidebar');
    if (!panel) return false;
    try {
      var style = window.getComputedStyle(panel);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return panel.offsetHeight > 80;
    } catch (e) {
      return false;
    }
  }

  function initStickyAtc() {
    var bar = document.getElementById('StickyAtc');
    var form = document.getElementById('AddToCartForm');
    var originalBtn =
      document.querySelector('[data-product-atc]') ||
      document.querySelector('.product-info__cart-btn');

    if (!bar || !form || !originalBtn) return;
    if (bar._stickyCleanup) bar._stickyCleanup();

    var stickyBtn = bar.querySelector('[data-sticky-atc-btn]');
    if (!stickyBtn) return;

    var stickyImage = bar.querySelector('[data-sticky-atc-image]');
    var optionsWrap =
      form.querySelector('.product-options') ||
      form.querySelector('.option-values') ||
      originalBtn;
    var originalInView = true;
    var submitting = false;
    var observers = [];
    var listeners = [];
    var ticking = false;
    var lastOffset = -1;

    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts || false);
      listeners.push([target, type, fn, opts || false]);
    }

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function updateStickyImage(variant) {
      if (!stickyImage || !variant) return;
      var img = variant.featured_image;
      if (!img) return;
      var src = img.src || img;
      if (typeof src !== 'string') return;
      var thumb = src;
      if (src.indexOf('cdn.shopify.com') !== -1) {
        thumb = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=144';
      }
      stickyImage.src = thumb;
      if (img.alt) stickyImage.alt = img.alt;
    }

    function applyOffset() {
      var offset = 0;
      try {
        offset = measureBottomOffset();
      } catch (e) {
        offset = 0;
      }
      if (offset === lastOffset) return;
      lastOffset = offset;
      document.documentElement.style.setProperty('--sticky-atc-offset', offset + 'px');
      if ((bar.getAttribute('data-sticky-position') || 'bottom') === 'bottom') {
        bar.style.bottom = offset + 'px';
        bar.style.top = '';
      } else {
        bar.style.top = '0px';
        bar.style.bottom = '';
      }
    }

    function readOriginalInView() {
      var rect = originalBtn.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight && rect.height > 0;
    }

    function setVisible(show) {
      var drawerOpen = false;
      try {
        drawerOpen = cartDrawerOpen();
      } catch (e) {}
      var allow = isMobile() && show && !drawerOpen;
      bar.classList.toggle('is-visible', allow);
      bar.setAttribute('aria-hidden', allow ? 'false' : 'true');
    }

    function syncFromOriginal() {
      if (submitting) return;

      var text = (originalBtn.textContent || '').replace(/\s+/g, ' ').trim();
      var disabled = originalBtn.disabled || originalBtn.id === 'soldout';
      var soldOut = disabled || /sold\s*out/i.test(text);
      var hasOptions = form.querySelectorAll('.option-value').length > 0;
      var hasActive = form.querySelectorAll('.option-value.active').length > 0;
      var atcFallback =
        (typeof window.addToCartLabel === 'string' && window.addToCartLabel) || 'ADD TO CART';
      var soldFallback =
        (typeof window.soldOutLabel === 'string' && window.soldOutLabel) || 'SOLD OUT';

      if (soldOut) {
        stickyBtn.textContent = soldFallback;
        stickyBtn.disabled = true;
        stickyBtn.setAttribute('data-sticky-mode', 'soldout');
      } else if (hasOptions && !hasActive) {
        stickyBtn.textContent = 'SELECT SIZE';
        stickyBtn.disabled = false;
        stickyBtn.setAttribute('data-sticky-mode', 'select');
      } else {
        stickyBtn.textContent = text || atcFallback;
        stickyBtn.disabled = false;
        stickyBtn.setAttribute('data-sticky-mode', 'add');
      }
    }

    function updateVisibility() {
      applyOffset();
      originalInView = readOriginalInView();
      setVisible(!originalInView);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateVisibility();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (entry) originalInView = entry.isIntersecting;
          applyOffset();
          setVisible(!originalInView);
        },
        { root: null, threshold: 0, rootMargin: '0px' }
      );
      io.observe(originalBtn);
      observers.push(io);
    }

    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', function () {
      lastOffset = -1;
      updateVisibility();
    });

    form.querySelectorAll('.option-value').forEach(function (btn) {
      on(btn, 'click', function () {
        setTimeout(syncFromOriginal, 0);
      });
    });

    on(document, 'variant:change', function (event) {
      syncFromOriginal();
      if (event && event.detail && event.detail.variant) {
        updateStickyImage(event.detail.variant);
      }
    });

    on(document, 'cart:item-added', function () {
      submitting = false;
      stickyBtn.textContent = 'ADDED';
      stickyBtn.disabled = true;
      setTimeout(function () {
        submitting = false;
        syncFromOriginal();
      }, 900);
    });

    if ('MutationObserver' in window) {
      var btnObs = new MutationObserver(syncFromOriginal);
      btnObs.observe(originalBtn, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'id']
      });
      observers.push(btnObs);
    }

    on(stickyBtn, 'click', function (e) {
      e.preventDefault();
      if (submitting) return;

      var mode = stickyBtn.getAttribute('data-sticky-mode');
      if (mode === 'soldout') return;

      if (mode === 'select') {
        optionsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) {
        optionsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (originalBtn.disabled || originalBtn.id === 'soldout') {
        syncFromOriginal();
        return;
      }

      submitting = true;
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'ADDING…';

      form.setAttribute('data-sticky-submit', 'true');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(originalBtn.type === 'submit' ? originalBtn : undefined);
      } else {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }

      setTimeout(function () {
        if (submitting) {
          submitting = false;
          form.removeAttribute('data-sticky-submit');
          syncFromOriginal();
        }
      }, 4000);
    });

    bar._stickyCleanup = function () {
      listeners.forEach(function (args) {
        args[0].removeEventListener(args[1], args[2], args[3]);
      });
      observers.forEach(function (obs) {
        if (obs.disconnect) obs.disconnect();
      });
      bar.classList.remove('is-visible');
      document.documentElement.style.removeProperty('--sticky-atc-offset');
    };

    syncFromOriginal();
    updateVisibility();
  }

  function boot() {
    try {
      initPromo();
    } catch (e) {}
    try {
      initStickyAtc();
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
